import React, { useCallback, useEffect, useState } from "react";
import { Switch } from 'antd';
import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Pagination from '@material-ui/lab/Pagination';

// core components
import MyVerticallyCenteredModal from "views/MyVerticallyCenteredModal/MyVerticallyCenteredModal";
import ModalTransferStorage from "components/ModalTransferStorage/ModalTransferStorage";
import TableStorage from "components/TableStorages/TableStorages"
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import CardIcon from "components/Card/CardIcon.js";
import CardFooter from "components/Card/CardFooter.js";
import api from "assets/services/api.js";
import useAuth from "hooks/useAuth";
import { formatDateFilter } from "services/formatDate.js"

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  colorCard: {
    color: "#999"
  },
  floatRight: {
    float: "right"
  },
  maxwidht: {
    maxWidth: "107%"
  },
  toogleclass: {
    marginTop: "14px",
    marginBottom: "14px",
    width: "65%",
  },
  backGreen: {
    backgroundColor: "#4caf50"
  },
  backRed: {
    backgroundColor: "rgb(244 67 54 / 1)"
  },
  zindex: {
    zIndex: "0 !important"
  },
  marginDate: {
    marginTop: "12px",
    marginBottom: "12px"
  }
};


const useStyles = makeStyles(styles);


export default function TableList() {
  const classes = useStyles();
  const { storageId, garlicType } = useAuth();
  const [storages, setStorages] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [toogle, setToggle] = useState(false);
  const [toogleTransfer, setToggleTransfer] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [modalShow, setModalShow] = useState(false);
  const [modalShowTransfer, setModalShowTransfer] = useState(false);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    loadStorage();
  }, [])

  useEffect(() => {
    loadStorage();
  }, [page, startDate, endDate, toogle, toogleTransfer, garlicType]);

  const loadModal = async () => {
    setModal(true);
  }
  const openModal = () => {
    if (!modalShow) {
      loadModal();
    }
    setModalShow(true);
  };
  const openModalTransfer = () => {
    if (!modal) {
      loadModal();
    }
    setModalShowTransfer(true);
  };

  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const toogler = () => {
    toogle ? setToggle(false) : setToggle(true);
  }

  const tooglerTransfer = () => {
    toogleTransfer ? setToggleTransfer(false) : setToggleTransfer(true);
  }

  const handleChange = (event, value) => {
    setPage(value);
  };

  const loadStorage = async () => {
    try {
      const response = await api.get(`/storage/admin/${storageId}?date_init=${startDate}&date_end=${endDate}&page=${page}&validated=${toogle}&garlic=${garlicType}&transfer=${toogleTransfer}`);
      setStorages(response.data.storage);
      setTotalPages(response.data.totalCount);
    } catch (error) {
      // alert('erro: ' + error)
    }

  };

  return (

    <GridContainer>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
              <CardIcon color="success">
                <Icon>content_copy</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Clique abaixo para adicionar estoque a operação</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Button color="success" className={classes.margintp + classes.maxwidht} onClick={() => openModal()}>
              Adicionar estoque
            </Button>
          </CardFooter>
        </Card>
      </GridItem>
      {storageId === 8 || storageId === 11 ?
        <GridItem xs={12} sm={6} md={2}>
          <Card>
            <div className={classes.zindex}>
              <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                <CardIcon color="info">
                  <Icon>content_copy</Icon>
                </CardIcon>
              </CardHeader>
            </div>
            <CardBody className="d-flex justify-content-center">
              <p className={classes.colorCard}>Clique abaixo para transferir estoque a outra operação</p>
            </CardBody>
            <CardFooter className="d-flex justify-content-center" stats>
              <Button color="info" className={classes.margintp + classes.maxwidht} onClick={() => openModalTransfer()}>
                Transferir estoque
              </Button>

            </CardFooter>
          </Card>
        </GridItem> : ""
      }
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center zindex {classes.zindex}" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>today</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Clique abaixo para inserir <b>filtro</b> de data primária</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={startDate}
              onChange={date => setStartDate(date)}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              locale={pt}
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>event</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Clique abaixo para inserir <b>filtro</b> de data secundária </p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={endDate}
              onChange={date => setEndDate(date)}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              locale={pt}
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="info">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Clique abaixo para inserir <b>filtro</b> para estoques validados ou não</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={toogler} />
          </CardFooter>
        </Card>
      </GridItem>
      {storageId === 8 || storageId === 11 ? <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="info">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Clique abaixo para inserir <b>filtro</b> para estoques validados ou não</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={tooglerTransfer} />
          </CardFooter>
        </Card>
      </GridItem> : ""}

      {storages.map(storage => (
        <TableStorage key={String("Storage_" + storage.id)} garlicType={garlicType} storage={storage} loadStorage={loadStorage} toogle={toogle} />
      ))}

      <Pagination count={totalPages} page={page} onChange={handleChange} />

      {modal && modalShow && (
        <MyVerticallyCenteredModal key={String("Add_" + storageId)} loadStorage={loadStorage} show={modalShow} onHide={() => setModalShow(false)} />
      )}
      {modalShowTransfer && modal && (
        <ModalTransferStorage key={String("Add_" + storageId)} show={modalShowTransfer} onHide={() => setModalShowTransfer(false)} />
      )}
    </GridContainer>


  );

}
